import React, { useMemo } from 'react';

import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@material-ui/core';

import { AnalyticsRecord } from '../types';
import { DashboardFilters } from '@lib/common/hooks/use-analysis';

interface Props {
  records: AnalyticsRecord[];
  filters: DashboardFilters;
  setFilters: React.Dispatch<React.SetStateAction<DashboardFilters>>;
}

const ALL = 'All';

const FiltersBar = ({
  records,
  filters,
  setFilters,
}: Props) => {
   // console.log("records", records)
  const fieldOptions = useMemo(() => {
    return [
      ALL,
      ...Array.from(
        new Set(records.map(r => r.fieldName))
      ).sort(),
    ];
  }, [records]);
  
const actionOptions = useMemo(() => {
  return [
    ALL,
    ...Array.from(
      new Set(
        records
          .filter(r => r.action !== 'Total')
          .map(r => r.action)
      )
    ),
  ];
}, [records]);

  return (
    <Grid container spacing={3} alignItems="center">

      <Grid item xs={12} md={5}>

        <FormControl fullWidth variant="outlined">

          <InputLabel>
            Field Name
          </InputLabel>

          <Select
            value={filters.field}
            label="Field Name"
            onChange={event =>
              setFilters(prev => ({
                ...prev,
                field: event.target.value as string,
              }))
            }
          >
            {fieldOptions.map(option => (
              <MenuItem
                key={option}
                value={option}
              >
                {option}
              </MenuItem>
            ))}
          </Select>

        </FormControl>

      </Grid>

      <Grid item xs={12} md={5}>

        <FormControl fullWidth variant="outlined">

          <InputLabel>
            Action
          </InputLabel>

          <Select
            value={filters.action}
            label="Action"
            onChange={event =>
              setFilters(prev => ({
                ...prev,
                action: event.target.value as string,
              }))
            }
          >
            {actionOptions.map(option => (
              <MenuItem
                key={option}
                value={option}
              >
                {option}
              </MenuItem>
            ))}
          </Select>

        </FormControl>

      </Grid>

      <Grid item xs={12} md={2}>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() =>
            setFilters({
              field: ALL,
              action: ALL,
              period:'week'
            })
          }
        >
          Reset
        </Button>

      </Grid>

    </Grid>
  );
};

export default FiltersBar;